export default __webpack_public_path__ + "static/media/Icon feather-arrow-right-circle-grey.e204fd7c.svg";